import { render, staticRenderFns } from "./Insured.vue?vue&type=template&id=6855067e&scoped=true&"
import script from "./Insured.vue?vue&type=script&lang=js&"
export * from "./Insured.vue?vue&type=script&lang=js&"
import style0 from "./Insured.vue?vue&type=style&index=0&id=6855067e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6855067e",
  null
  
)

export default component.exports